import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useUpdateOption = function (id) {
    return useApiCall(function (signal, id, payload) { return api.option.apiOptionDataIdPut(id, payload, { signal: signal }); }, {}, !!id, [id]);
};
